// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"investor-details-tabs_tabsWrapper__m8YW2","invTabs":"investor-details-tabs_invTabs__8gRwl"};